.base {
    flex: 1;
    display: flex;
}